module.exports = __webpack_public_path__ + "media/certifications/phone-56e7aeaf.webp";